import { useModalContext } from 'utils/contexts/modal';
import { useListsContext, useSelectionContext } from '../../../contexts';
import { isSelectionContent, isSelectionFolder } from 'utils/contexts/selection';
import { useCallback } from 'react';
import { useDeleteListsAndFolders } from '../../../hooks/folders';
import { keyBy } from 'lodash';
import noop from 'utils/noop';
import { useDeleteListModalDisplayText } from './useDeleteListModalDisplayText';

export const useDeleteListFolderModalState = () => {
  const { refetch } = useListsContext();
  const { hideModal } = useModalContext();
  const { active } = useSelectionContext();
  const displayTextForContentItems = useDeleteListModalDisplayText();

  const selectedFolders = active.filter(isSelectionFolder);
  const selectedContent = active.filter(isSelectionContent);

  const [deleteListAndFolders] = useDeleteListsAndFolders({
    onComplete: hideModal,
    onSuccess: refetch,
    onError: noop,
    itemsById: keyBy(active, 'id'),
  });

  const onDelete = useCallback(() => {
    const contentIds = selectedContent.map((c) => c.id);
    const folderIds = selectedFolders.map((c) => c.id);
    deleteListAndFolders({
      variables: {
        contentIds,
        folderIds,
      },
    });
  }, [selectedFolders, selectedContent, deleteListAndFolders]);

  const onClose = hideModal;

  return {
    folders: selectedFolders,
    content: selectedContent,
    onClose,
    onDelete,
    displayTextForContentItems,
  };
};
